module.exports = __webpack_public_path__ + "img/scriptSQL.3e3321bb.png";